import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { MensajesModel } from "../../models/Mensajes.model";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { TooltipsModel } from "../../models/tooltips.model";
import { LocalStorageEnum } from "../../enum/localstorage.enum";
import { environment } from "src/environments/environment";
import { IdentificadorMensajesEnum } from "../../enum/mensajes.enum";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MensajesService {
  private readonly url = environment.URL_HOME;
  firstMenuEmmiter: EventEmitter<any> = new EventEmitter<any>();
  labelTextEmmiter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {
    this.setMensajes(environment.institucion);
    this.setTooltips(environment.institucion);
  }

  setMensajes(institucion: string): any {
    const params = { institucion };
    this.subMessajes(params).subscribe((response: MensajesModel) => {
      localStorage.setItem(LocalStorageEnum.Mensajes, JSON.stringify(response));
      this.firstMenuEmmiter.emit(
        this.getMensajeByEtiquetaBypassSecurityTrustHtml(
          IdentificadorMensajesEnum.disclaimer
        )
      );
    });
  }

  subMessajes(params): Observable<any> {
    return this.http.get<MensajesModel>(`${this.url}/GetMensajes`, { params });
  }

  setTooltips(institucion: string): any {
    const params = { institucion };
    this.subTooltips(params).subscribe((response: TooltipsModel) => {
      localStorage.setItem(LocalStorageEnum.Tooltips, JSON.stringify(response));
      this.labelTextEmmiter.emit(true);
    });
  }

  subTooltips(params: { institucion: string }): Observable<any> {
    return this.http.get<TooltipsModel>(`${this.url}/GetTooltips`, { params });
  }

  getMensajeByEtiqueta(etiqueta: string): string {
    const mensajes = localStorage.getItem(LocalStorageEnum.Mensajes);
    if (!mensajes) return "";
    const mensajesJson = JSON.parse(mensajes) as MensajesModel;
    return (
      mensajesJson.data.attributes.filter((msj) => msj.etiqueta === etiqueta)[0]
        ?.mensaje || ""
    );
  }

  getTooltipByEtiqueta(etiqueta: string): string {
    const mensajes = localStorage.getItem(LocalStorageEnum.Tooltips);
    if (!mensajes) return "";
    const mensajesJson = JSON.parse(mensajes) as MensajesModel;
    return (
      mensajesJson.data.attributes.filter((msj) => msj.etiqueta === etiqueta)[0]
        ?.tooltip || ""
    );
  }

  getMensajeByEtiquetaBypassSecurityTrustHtml(
    etiqueta: string
  ): SafeHtml | string {
    const mensaje: string = this.getMensajeByEtiqueta(etiqueta);
    return this.sanitizer.bypassSecurityTrustHtml(mensaje);
  }

  getTooltipByEtiquetaBypassSecurityTrustHtml(
    etiqueta: string
  ): SafeHtml | string {
    const mensaje: string = this.getTooltipByEtiqueta(etiqueta);
    return this.sanitizer.bypassSecurityTrustHtml(mensaje);
  }
}
